import getData from './getData'
export default {
  getData
}



// WEBPACK FOOTER //
// ./src/axios/response_interceptors/index.js